import EuroIcon from "@mui/icons-material/Euro";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CurrencyPoundIcon from "@mui/icons-material/CurrencyPound";
import CurrencyRubleIcon from "@mui/icons-material/CurrencyRuble";
import PaymentsIcon from "@mui/icons-material/Payments";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";

export const LOW_STOCK_THRESHOLD = 20;

export function getStockStatus(quantity) {
  if (quantity <= 0) {
    return { key: "out", label: "OutOfStock", color: "error" };
  }
  if (quantity <= LOW_STOCK_THRESHOLD) {
    return { key: "low", label: "LowStock", color: "warning" };
  }
  return { key: "ok", label: "InStock", color: "success" };
}

// A currency is purely a display label here - no conversion, no effect on
// any stored value. RSD and BAM have no dedicated MUI currency icon, so
// they get distinct generic ones rather than reusing one fallback for both.
export const DEFAULT_CURRENCY = "EUR";

export const CURRENCIES = {
  EUR: { symbol: "€", labelKey: "CurrencyEur", Icon: EuroIcon },
  USD: { symbol: "$", labelKey: "CurrencyUsd", Icon: AttachMoneyIcon },
  GBP: { symbol: "£", labelKey: "CurrencyGbp", Icon: CurrencyPoundIcon },
  RUB: { symbol: "₽", labelKey: "CurrencyRub", Icon: CurrencyRubleIcon },
  RSD: { symbol: "RSD", labelKey: "CurrencyRsd", Icon: PaymentsIcon },
  BAM: { symbol: "KM", labelKey: "CurrencyBam", Icon: CurrencyExchangeIcon },
};

export function formatCurrency(value, currency = DEFAULT_CURRENCY) {
  const symbol = CURRENCIES[currency]?.symbol ?? CURRENCIES[DEFAULT_CURRENCY].symbol;
  return `${Number(value).toFixed(2)} ${symbol}`;
}
